import React, { Component } from 'react';
import {
  View,
  Text,
  ScrollView,
  Easing,
  Platform,
  TouchableHighlight,
  Animated,
  TextInput,
  Dimensions,
  Image,
  Clipboard, 
  Alert
} from 'react-native';
import {StyleContext,styleInfo} from '../styleC';

import info from '../info';
import firebase from './firebase';
import { getAuth,  } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue} from "firebase/database";
import strings from '../strings';
import MavAlert from './mavAlert';
import MavButton from './mavButton';
import SortableList from './SortableList';
import Trajet from "./trajet"
import MavNavigationMinimize from './mavNavigationMinimize';
import MavInfoBubble from './mavInfoBubble';
import TextPresentation from './textPresentation';
import MavMiniButton from './mavMiniButton';
import RNFetchBlob from './RNFetchBlob';
import Qs from 'qs';



export default class account extends Component {
  constructor(props) {
    super(props);
    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 

    if(Platform.OS!="web"){
      if(params!=undefined && params.viewMode=="favoriteAdmin") this.props.navigation.setOptions({ title: strings.poi })
      else if(params!=undefined && params.viewMode=="pickup") this.props.navigation.setOptions({ title: strings.pickUpLocation })
      else if(params!=undefined && params.viewMode=="defineFakeCar") this.props.navigation.setOptions({ title: "Voiture simulée" })
      else this.props.navigation.setOptions({ title: strings.myFavorite })
    }    


    const style=styleInfo();

    const iconList=[
        {name:"no",icon:"", textList:{fr:"Aucune icône"}},

        {name:"flight",icon:(style.mode=="dark")?require('../assets/favorite/flight_white.png'):require('../assets/favorite/flight_black.png'), textList:{fr:"Avion"} },
        {name:"train",icon:(style.mode=="dark")?require('../assets/favorite/train_white.png'):require('../assets/favorite/train_black.png'), textList:{fr:"Train"}},
        {name:"home",icon:(style.mode=="dark")?require('../assets/favorite/home_white.png'):require('../assets/favorite/home_black.png'), textList:{fr:"Maison"}},
        {name:"bus",icon:(style.mode=="dark")?require('../assets/favorite/bus_white.png'):require('../assets/favorite/bus_black.png'), textList:{fr:"Bus"}},
        {name:"portfolio",icon:(style.mode=="dark")?require('../assets/favorite/portfolio_white.png'):require('../assets/favorite/portfolio_black.png'), textList:{fr:"Porte-document"}},
        {name:"restaurant",icon:(style.mode=="dark")?require('../assets/favorite/restaurant_white.png'):require('../assets/favorite/restaurant_black.png'), textList:{fr:"Restaurant"}},
        {name:"bed",icon:(style.mode=="dark")?require('../assets/favorite/bed_white.png'):require('../assets/favorite/bed_black.png'), textList:{fr:"Lit"}},
        {name:"library",icon:(style.mode=="dark")?require('../assets/favorite/library_white.png'):require('../assets/favorite/library_black.png'), textList:{fr:"Monument"}},
        {name:"foot",icon:(style.mode=="dark")?require('../assets/favorite/foot_white.png'):require('../assets/favorite/foot_black.png'), textList:{fr:"Ballon"}},
        {name:"cinema",icon:(style.mode=="dark")?require('../assets/favorite/cinema_white.png'):require('../assets/favorite/cinema_black.png'), textList:{fr:"Cinéma"}},
        {name:"ferry",icon:(style.mode=="dark")?require('../assets/favorite/ferry_white.png'):require('../assets/favorite/ferry_black.png'), textList:{fr:"Ferry"}},
        {name:"bar",icon:(style.mode=="dark")?require('../assets/favorite/bar_white.png'):require('../assets/favorite/bar_black.png'), textList:{fr:"Bar"}},
        {name:"caddy",icon:(style.mode=="dark")?require('../assets/favorite/caddy_white.png'):require('../assets/favorite/caddy_black.png'), textList:{fr:"Caddy"}},
        {name:"heart",icon:(style.mode=="dark")?require('../assets/favorite/heart_white.png'):require('../assets/favorite/heart_black.png'), textList:{fr:"Coeur"}},
        {name:"park",icon:(style.mode=="dark")?require('../assets/favorite/park_white.png'):require('../assets/favorite/park_black.png'), textList:{fr:"Parc"}},
        {name:"attraction",icon:(style.mode=="dark")?require('../assets/favorite/attraction_white.png'):require('../assets/favorite/attraction_black.png'), textList:{fr:"Attraction"}},
        {name:"hospital",icon:(style.mode=="dark")?require('../assets/favorite/hospital_white.png'):require('../assets/favorite/hospital_black.png'), textList:{fr:"Hopital"}},
        {name:"doctor",icon:(style.mode=="dark")?require('../assets/favorite/doctor_white.png'):require('../assets/favorite/doctor_black.png'), textList:{fr:"Docteur"}},
        {name:"pharmacy",icon:(style.mode=="dark")?require('../assets/favorite/pharmacy_white.png'):require('../assets/favorite/pharmacy_black.png'), textList:{fr:"Pharmacie"}},
        {name:"briefcase",icon:(style.mode=="dark")?require('../assets/favorite/briefcase_white.png'):require('../assets/favorite/briefcase_black.png'), textList:{fr:"Trousse"}},
        {name:"university",icon:(style.mode=="dark")?require('../assets/favorite/university_white.png'):require('../assets/favorite/university_black.png'), textList:{fr:"Université"}},
        {name:"hatGrad",icon:(style.mode=="dark")?require('../assets/favorite/hatGrad_white.png'):require('../assets/favorite/hatGrad_black.png'), textList:{fr:"Diplôme"}},
        {name:"vehiculeR",icon:(style.mode=="dark")?require('../assets/favorite/vehiculeR_white.png'):require('../assets/favorite/vehiculeR_black.png'), textList:{fr:"Véhicule de face"}},

      ] 

    var favoritePickUp=[]; 
    if(params!=undefined && params.favoritePickUp!=undefined){
      var i; 
      var lisFPU=Object.keys(params.favoritePickUp);
      for(i=0;i<lisFPU.length;i++){

          if(params.favoritePickUp[lisFPU[i]].pickUpLocationDescription!=undefined){
              var elemd=params.favoritePickUp[lisFPU[i]];
              
              if(elemd.icon && iconList.findIndex(x => x.name === elemd.icon)>0 && iconList[iconList.findIndex(x => x.name === elemd.icon)]!=undefined){
                elemd.iconInfo=iconList[iconList.findIndex(x => x.name === elemd.icon)].icon
                
              } 

              favoritePickUp.push(elemd)
          }
      }
    
    }




    this.state = {
      admin:false,
      params:params,
      viewMode:params.viewMode,

      favorite:{},
      favoriteList:{},
      favoriteListSave:{}, 
      favoriteGlobal:{},
      disableNavigation:(params!=undefined && params.disableNavigation==true && Platform.OS=="web")?true:false,
      pickUpLocation:(params!=undefined && params.pickUpLocation==true)?true:false,
      favoritePickUp:favoritePickUp,
      descriptionName:"",
      defineFakeCar:(params!=undefined && params.defineFakeCar==true)?true:false,
      uuid:"",
      actualFavoriteIndex:"",
      favoritePlaceWaiting:"",
      favoritePlaceWaitingDest:"",
      defineFakeCarSelect:"", 
      selected:-1,
      iconSelected:0,
      iconList:iconList
    };
  }

  findIcon(name){
    const style=styleInfo();

    var ico=(style.mode=="dark")?require('../assets/favorite/pin_white.png'):require('../assets/favorite/pin_black.png')
    var txt=strings.noIcon; 
    var i; 
    for(i=0; i<this.state.iconList.length;i++){
      if(this.state.iconList[i].name==name) {
        ico=this.state.iconList[i].icon;
        txt=this.state.iconList[i].textList.fr;
      } 
    }

    return {icon:ico, text:txt};  
  }


  chooseIcon(rowData){
    const style=styleInfo();
    var items=[]
    var selected=-1;
    var i; 

    for(i=0; i<this.state.iconList.length;i++){
      if(this.state.favoriteList[rowData].icon==this.state.iconList[i].name) selected=i;
      items.push({text:this.state.iconList[i].textList.fr, image:this.state.iconList[i].icon })
    }
    this.alert.onAlert({title:strings.iconChoice,subTitle:strings.iconChoiceMoreInfo,items:items, itemSelected:selected,buttons:[{text: strings.validate,onPress: (value) => { var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].icon=this.state.iconList[value].name; this.setState({favoriteList:opt})   }},{text: strings.cancel,style:"cancel", onPress: () => {}}]})

  }

  componentDidMount() {

    if(this.state.viewMode=="favoriteAdmin"){

      get(child(ref(getDatabase(firebase)), '/favorite')).then(value => {
        var val = value.val();

        if(val!=null) {
            this.setState({favoriteList:val, favoriteListSave:JSON.parse(JSON.stringify(val))})
        }
      })



    } else if(this.state.viewMode=="favoriteUser"){

      get(child(ref(getDatabase(firebase)), 'users/' + getAuth(firebase).currentUser.uid+"/favorite/")).then(value => {
        var val = value.val();

        if(val!=null) {
            this.setState({favoriteList:val, favoriteListSave:JSON.parse(JSON.stringify(val))})
        }
      })
    }


  }

  onFavoritePlaceStart= (data) => {this['trajetStart'].close();  this.setState({favoritePlaceWaiting:data},() =>{this.calculatePath()})  }
  onFavoritePlaceEnd= (data) => {this['trajetEnd'].close(); this.setState({favoritePlaceWaitingDest:data},() =>{this.calculatePath()}) }

  



  angle(cx, cy, ex, ey) {
    var dy = ey - cy;
    var dx = ex - cx;
    var theta = Math.atan2(dy, dx); // range (-PI, PI]
    theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    return theta;

  }



   decode(t, e) {
          for (
            var n,
              o,
              u = 0,
              l = 0,
              r = 0,
              d = [],
              h = 0,
              i = 0,
              a = null,
              c = Math.pow(10, e || 5);
            u < t.length;

          ) {
            (a = null), (h = 0), (i = 0);
            do
              (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
            while (a >= 32);
            (n = 1 & i ? ~(i >> 1) : i >> 1), (h = i = 0);
            do
              (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
            while (a >= 32);
            (o = 1 & i ? ~(i >> 1) : i >> 1), (l += n), (r += o), d.push([
              l / c,
              r / c,
            ]);
          }
          return (d = d.map(function(t) {
            return { latitude: t[0], longitude: t[1], lat:t[0], lng:t[1] };
          }));
  }


  calculatePath = data => {

    if(this.state.favoritePlaceWaitingDest!="" && this.state.favoritePlaceWaiting!=""){
      var uur='https://maps.googleapis.com/maps/api/directions/json?origin='+this.state.favoritePlaceWaiting.userDescription+'&destination='+this.state.favoritePlaceWaitingDest.userDescription+' &key='+info.googleMapsKey;
     
       fetch(uur)
        .then(response => response.json())
        .then(responseJson => {
          var i;
          var coor=this.decode(responseJson.routes[0].overview_polyline.points)
          var duration=(responseJson.routes[0].legs[0].duration.value*1000)/coor.length;
          for(i=1;i<coor.length;i++){
            coor[i]={
              latitude:coor[i].latitude,
              longitude:coor[i].longitude,
              duration:duration,
              rotation:this.angle(coor[i-1].latitude,coor[i-1].longitude,coor[i].latitude,coor[i].longitude)
            }
          }
      this.copyToClipboard(JSON.stringify(coor)+",")
      this.alert.onAlert({title:strings.copiedClipboard }) 

      
      

     })

    }

  }

  copyToClipboard(text){

      Clipboard.setString(text);

}


  updateFavoriteNext= (rowData, position,coor, urlImage) => { 
            
            var opt=JSON.parse(JSON.stringify(this.state.favoriteList))


             /*si j'ai une image et que différent de celle d'avant*/
            if(opt[rowData].picture!=undefined && opt[rowData].changePicture==true && urlImage==undefined){

              if(this.state.favoriteListSave!=undefined && this.state.favoriteListSave[rowData]!=undefined && this.state.favoriteListSave[rowData].picture!=undefined){

                var elemSup=JSON.parse(JSON.stringify(this.state.favoriteListSave[rowData].picture));

                /*je supprime l'ancienne image*/
                getAuth(firebase).currentUser.getIdToken().then(token => {

                  var bodyRemove={bundleIdentifer:info.bundleIdentifer,dataType:elemSup.dataType, bundleAdress:info.firebaseProjectID,token:token,userID:getAuth(firebase).currentUser.uid,uuid:elemSup.uuid,}
                  if(Platform.OS=="web") fetch('https://52ea3f3.online-server.cloud/remove',{method: 'POST',headers: {'Content-Type': 'application/json',}, body: JSON.stringify(bodyRemove)})
                  else RNFetchBlob.fetch('POST','https://52ea3f3.online-server.cloud/remove',{ 'Content-Type': 'application/json'},JSON.stringify(bodyRemove)).then(response => { console.log(response) })


                })

              }


              /*j'envoi l'image*/

              getAuth(firebase).currentUser.getIdToken().then(token => {

                var bodyInfo={
                    bundleIdentifer:info.bundleIdentifer,
                    bundleAdress:info.firebaseProjectID,
                    token:token,
                    userID:getAuth(firebase).currentUser.uid,
                    data:opt[rowData].picture.data,
                    pictureUsage:"favorite",
                    dataType:opt[rowData].picture.dataType,
                }
                if(Platform.OS=="web") fetch('https://52ea3f3.online-server.cloud/upload',{method: 'POST',headers: {'Content-Type': 'application/json',}, body: JSON.stringify(bodyInfo)}).then((response) => response.json()).then((data) => { if(typeof(data)=="string") data=JSON.parse(data);  this.updateFavoriteNext(rowData, position,coor, data) })
                else RNFetchBlob.fetch('POST','https://52ea3f3.online-server.cloud/upload',{ 'Content-Type': 'application/json'},JSON.stringify(bodyInfo)).then(response => {if(typeof(response.data)=="string") response.data=JSON.parse(response.data);  this.updateFavoriteNext(rowData, position,coor, response.data) })




            })


              

            }


            else {
                if(opt[rowData].index==undefined) {opt[rowData].index=Object.keys(this.state.favoriteListSave).length; this.setState({addFavoriteSelected:false}) }

                delete opt[rowData].notSaved;
                if(coor!="") {
                  opt[rowData].coordinates=coor
                  delete opt[rowData].placeID;
                }

                if(opt[rowData].picture!=undefined && opt[rowData].changePicture==true){
                delete opt[rowData].changePicture; 

                opt[rowData].picture={
                  dataType:opt[rowData].picture.dataType, 
                  name:opt[rowData].picture.name,
                  uuid:urlImage.uuid,
                  url:urlImage.url,
                }
              }



                var sendSave=JSON.parse(JSON.stringify(this.state.favoriteListSave))
                sendSave[rowData]=JSON.parse(JSON.stringify(opt[rowData]));


                var sendToFB=JSON.parse(JSON.stringify(opt));
                if(sendToFB[rowData].icon=="" || sendToFB[rowData].icon==undefined) delete sendToFB[rowData].icon;
                if(sendToFB[rowData].descriptionName=="" || sendToFB[rowData].descriptionName==undefined) delete sendToFB[rowData].descriptionName;
                if(sendToFB[rowData].descriptionLongName=="" || sendToFB[rowData].descriptionLongName==undefined) delete sendToFB[rowData].descriptionLongName;
                if(sendToFB[rowData].pickUpLocationDescription=="" || sendToFB[rowData].pickUpLocationDescription==undefined) delete sendToFB[rowData].pickUpLocationDescription;

                this.setState({favoriteList:opt,favoriteListSave:sendSave,}) 

                const fireInfo={} 
                if(this.state.viewMode=="favoriteAdmin") fireInfo["favorite/"+rowData]=sendToFB[rowData];
                else fireInfo['users/' + getAuth(firebase).currentUser.uid+"/favorite/"+rowData]=sendToFB[rowData];
                update(ref(getDatabase(firebase)), fireInfo)

                this['viewFavorite_' + position].close(); 



            }













        


  }


 removeFavorite(rowData, position){
    var opt=JSON.parse(JSON.stringify(this.state.favoriteList))
    if(this.state.favoriteList[rowData].index==undefined){
        delete opt[rowData]; 
        this.setState({favoriteList:opt, addFavoriteSelected:false}); 
    } else{
          this['viewFavorite_' + position].close(); 

          if(this.state.favoriteList!=undefined && this.state.favoriteList[rowData]!=undefined && this.state.favoriteList[rowData].picture!=undefined){

            var elemSup=JSON.parse(JSON.stringify(this.state.favoriteList[rowData].picture));

            /*je supprime l'ancienne image*/
            getAuth(firebase).currentUser.getIdToken().then(token => {
              
              var bodyRemove={bundleIdentifer:info.bundleIdentifer,dataType:elemSup.dataType, bundleAdress:info.firebaseProjectID,token:token,userID:getAuth(firebase).currentUser.uid,uuid:elemSup.uuid,}
              if(Platform.OS=="web") fetch('https://52ea3f3.online-server.cloud/remove',{method: 'POST',headers: {'Content-Type': 'application/json',}, body: JSON.stringify(bodyRemove)})
              else RNFetchBlob.fetch('POST','https://52ea3f3.online-server.cloud/remove',{ 'Content-Type': 'application/json'},JSON.stringify(bodyRemove)).then(response => {  })


            })

          }

          var optSave=JSON.parse(JSON.stringify(this.state.favoriteListSave))
          delete optSave[rowData];
          delete opt[rowData]; 

          var favoriteOrderArray=Object.keys(optSave).sort((a,b)=>{ return optSave[a].index-optSave[b].index} )
          var i; 
          for(i=0; i<favoriteOrderArray.length;i++){
            opt[favoriteOrderArray[i]].index=i; 
            optSave[favoriteOrderArray[i]].index=i; 
            
          }
          const fireInfo={} 
          if(this.state.viewMode=="favoriteAdmin") fireInfo["favorite/"]=optSave
          else fireInfo['users/' + getAuth(firebase).currentUser.uid+"/favorite/"]=optSave
          update(ref(getDatabase(firebase)), fireInfo)
          this.setState({favoriteListSave:optSave, favoriteList:opt})


    }

 }



  updateFavorite= (rowData, position) => { 
    console.log(this.state.favoriteList[rowData])

    if(this.state.favoriteList[rowData].userDescription=="" || this.state.favoriteList[rowData].userDescription==undefined) this.alert.onAlert({title:strings.thankWriteName})
    else if(this.state.favoriteList[rowData].description=="" || this.state.favoriteList[rowData].description==undefined ) this.alert.onAlert({title:strings.incorrectPricingStart})
    else{
        if(this.state.favoriteListSave[rowData]==undefined || this.state.favoriteList[rowData].description!=this.state.favoriteListSave[rowData].description){

          /*je vais récupérer l'adresse de ce point */
          var paramsRqs=Qs.stringify({fields: "geometry",key: info.googleMapsKey,placeid:this.state.favoriteList[rowData].placeID, language: 'fr',})
          var body={paramsRqs:paramsRqs, type:"placeDetails" }

          fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(body),method: "POST"}).then((response) => response.json()).then((responseJson) => {
                if(typeof(responseJson)!="object") responseJson=JSON.parse(responseJson);

                console.log(responseJson)
                if(responseJson.result!=undefined && responseJson.result.geometry!=undefined && responseJson.result.geometry.location!=undefined) {
                  this.updateFavoriteNext(rowData, position, {latitude:responseJson.result.geometry.location.lat, longitude:responseJson.result.geometry.location.lng} )
                }
                else this.alert.onAlert({title:strings.incorrectPricingStart})

        })
        

    }

    else this.updateFavoriteNext(rowData, position, "")

  }
}
  

  render() {
    return (
      <StyleContext.Consumer>{style =>
      <View style={{flex:1,backgroundColor:style.backgroundColor}}>
      {true && <ScrollView >
        {(Platform.OS=="web" && this.state.disableNavigation!=true) && <MavNavigationMinimize clickLeft={() => { this.state.params.goBack();  }} left={strings.return} title={ strings.myFavorite } />}

        <View style={{flex:1,marginLeft: 0, marginRight: 0, backgroundColor: style.backgroundColor}}>


          {this.state.viewMode=="pickup" && <View>
               {(Platform.OS=="web" && this.state.disableNavigation!=true) && <MavNavigationMinimize clickLeft={() => { this.state.params.goBack();  }} left={strings.return} title={ strings.pickUpLocation } />}
                {(this.state.favoritePickUp.length==0) && <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.noElement}</Text>}
                {(this.state.favoritePickUp.length>0) && <View> 

                    {this.state.favoritePickUp.map((rowData,i)=>(
                        <View style={{marginLeft:"10%",marginRight:"10%",marginTop:20}}>
                            <View style={{flexDirection: 'row',alignItems:"center",  marginBottom:10}}>
                              {(rowData.iconInfo!=undefined) && <Image source={rowData.iconInfo} style={{height:30,width:30,resizeMode:"contain", marginRight:10}}/> }
                              
                              <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*1.2,fontWeight: 'bold'}}>{rowData.userDescription}</Text>
                            </View>
                            <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*1,}}>{rowData.pickUpLocationDescription}</Text>
                            
                        </View>
                    ))}

                </View>}

           </View>}






            {this.state.viewMode=="defineFakeCar" && <View style={{flex: 1,backgroundColor: style.backgroundColor}}>

                 <TextPresentation ref={trajetStart => {this['trajetStart'] = trajetStart;}} style={{marginTop:5}} textInputFlex={1.5} text={(this.state.favoritePlaceWaiting.userDescription==undefined || this.state.favoritePlaceWaiting.userDescription=="")?strings.selectFrom:this.state.favoritePlaceWaiting.userDescription} textExplication={strings.start} editable={false} >
                        <Trajet params={{hideNavBar:true,searchLimited:5, backgroundColor:style.backgroundColorContrast, onFavoritePlace:this.onFavoritePlaceStart  }}/>
                  </TextPresentation>


                  <TextPresentation ref={trajetEnd => {this['trajetEnd'] = trajetEnd;}} style={{marginTop:5}} textInputFlex={1.5} text={(this.state.favoritePlaceWaitingDest.userDescription==undefined || this.state.favoritePlaceWaitingDest.userDescription=="")?strings.selectTo:this.state.favoritePlaceWaitingDest.userDescription} textExplication={strings.destination} editable={false} >
                        <Trajet params={{hideNavBar:true,searchLimited:5, backgroundColor:style.backgroundColorContrast, onFavoritePlace:this.onFavoritePlaceEnd  }}/>
                  </TextPresentation>


            </View>}






            {(this.state.viewMode=="favoriteAdmin" || this.state.viewMode=="favoriteUser") && <View >

                  {this.state.viewMode=="favoriteAdmin" && <MavInfoBubble type={"menu"} icon={(style.mode=="dark")?require('../assets/favorite/pin_white.png'):require('../assets/favorite/pin_black.png')} title={strings.yourPOI} subTitle={strings.yourPOIMoreInfo}  style={{marginTop:10,marginBottom:20}} />}
                  {this.state.viewMode=="favoriteAdmin" && <MavInfoBubble type={"help"} videoLink={"https://www.youtube.com/watch?v=QFq-3IEhkBU"} tutdoLink={"http://www.google.fr"} style={{marginTop:0,marginBottom:20}} />}



                  {Object.keys(this.state.favoriteList).sort((a,b)=>{ return this.state.favoriteList[a].index-this.state.favoriteList[b].index} ).map((rowData,i) => (


                     <TextPresentation ref={viewFavorite => {this['viewFavorite_' + i] = viewFavorite;}} textMini={(this.state.favoriteList[rowData].notSaved==true)?strings.notSaved:undefined} text={(this.state.favoriteList[rowData].userDescription!=undefined)?this.state.favoriteList[rowData].userDescription:strings.noNameFavorite} style={{marginTop:5}} icon={this.findIcon(this.state.favoriteList[rowData].icon).icon}    >
                    

                          <TextPresentation textExplicationSmall={strings.namePOIMoreInfo} suggestions={"adress"} text={(this.state.favoriteList[rowData].description==undefined || this.state.favoriteList[rowData].description=="")?"":this.state.favoriteList[rowData].description} textExplication={strings.adress} placeholder={strings.selectFrom}  onChangeText={(text)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].description=text; this.setState({favoriteList:opt})      }}  onSuggestion={(text)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].description=text.name; opt[rowData].placeID=text.placeID;  this.setState({favoriteList:opt})      }}  />
                          

                          <TextPresentation textExplicationSmall={strings.namePOIMoreInfo}  text={(this.state.favoriteList[rowData].userDescription!=undefined && this.state.favoriteList[rowData].userDescription!="")?this.state.favoriteList[rowData].userDescription:""} textExplication={strings.placeName}  placeholder={strings.placeName} onChangeText={(text)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].userDescription=text; this.setState({favoriteList:opt})      }}   />
                          

                          {(this.state.viewMode=="favoriteAdmin" && info.viewFavoriteCoor==true) && <TextPresentation text={(this.state.favoriteList[rowData].coordinates==undefined || this.state.favoriteList[rowData].coordinates.latitude=="")?"":this.state.favoriteList[rowData].coordinates.latitude.toString()} textExplication={"Latitude"} onChangeText={(text)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].coordinates={latitude:isNaN(parseFloat(text))?"":parseFloat(text), longitude:opt[rowData].coordinates.longitude}; this.setState({favoriteList:opt})      }}   />}
                          {(this.state.viewMode=="favoriteAdmin" && info.viewFavoriteCoor==true ) && <TextPresentation text={(this.state.favoriteList[rowData].coordinates==undefined || this.state.favoriteList[rowData].coordinates.longitude=="")?"":this.state.favoriteList[rowData].coordinates.longitude.toString()} textExplication={"Longitude"} onChangeText={(text)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].coordinates={longitude:isNaN(parseFloat(text))?"":parseFloat(text), latitude:opt[rowData].coordinates.latitude}; this.setState({favoriteList:opt})      }}   />}


                          {(this.state.viewMode=="favoriteAdmin") && <TextPresentation textExplicationSmall={strings.poiPicture} editable={false} text={(this.state.favoriteList[rowData].picture!=undefined)?( (this.state.favoriteList[rowData].picture.name.length>15)?(this.state.favoriteList[rowData].picture.name.slice(0,8)+"[...]"+this.state.favoriteList[rowData].picture.name.slice(this.state.favoriteList[rowData].picture.name.length-4, this.state.favoriteList[rowData].picture.name.length)) :this.state.favoriteList[rowData].picture.name):strings.noPicture} textExplication={strings.picture} choosePicture={(picture)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].changePicture=true;  opt[rowData].picture=picture; this.setState({favoriteList:opt})  }} />}

                          {(this.state.viewMode=="favoriteAdmin") && <TextPresentation forceClick={() => {this.chooseIcon(rowData)}}  textExplicationSmall={strings.iconChoiceMoreInfo} text={(this.state.favoriteList[rowData].icon!=undefined)?this.findIcon(this.state.favoriteList[rowData].icon).text:strings.noIcon} editable={false} textExplication={strings.iconChoice}   />}


                          {(this.state.viewMode=="favoriteAdmin" && this.state.favoriteList[rowData].icon=="flight" && false) && <TextPresentation textExplicationSmall={strings.iataMoreInfo} text={(this.state.favoriteList[rowData].iata!=undefined && this.state.favoriteList[rowData].iata!="")?this.state.favoriteList[rowData].iata:""} textExplication={strings.iata}  placeholder={strings.iata} onChangeText={(text)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].iata=text; this.setState({favoriteList:opt})      }}   />}


                          {(this.state.viewMode=="favoriteAdmin") && <TextPresentation textExplicationSmall={strings.descriptionShortPOIMoreInfo} text={(this.state.favoriteList[rowData].descriptionName!=undefined && this.state.favoriteList[rowData].descriptionName!="")?this.state.favoriteList[rowData].descriptionName:""} textExplication={strings.descriptionShort}  placeholder={strings.description} onChangeText={(text)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].descriptionName=text; this.setState({favoriteList:opt})      }}   />}
                          
                          {(this.state.viewMode=="favoriteAdmin") && <TextPresentation textExplicationSmall={strings.descriptionLongPOIMoreInfo} multiline={true}  text={(this.state.favoriteList[rowData].descriptionLongName!=undefined && this.state.favoriteList[rowData].descriptionLongName!="")?this.state.favoriteList[rowData].descriptionLongName:""} textExplication={strings.descriptionLong}  placeholder={strings.descriptionLong} onChangeText={(text)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].descriptionLongName=text; this.setState({favoriteList:opt})      }}   />}
                         
                          {(this.state.viewMode=="favoriteAdmin" && this.state.pickUpLocation==true) && <TextPresentation textExplicationSmall={strings.pickUpLocationPOIMoreInfo} multiline={true}  text={(this.state.favoriteList[rowData].pickUpLocationDescription!=undefined && this.state.favoriteList[rowData].pickUpLocationDescription!="")?this.state.favoriteList[rowData].pickUpLocationDescription:""} textExplication={strings.pickUpLocation}  placeholder={"Ex : Au rez-de-chaussée, en face de la porte T2E1"} onChangeText={(text)=>{  var opt=this.state.favoriteList;  opt[rowData].notSaved=true; opt[rowData].pickUpLocationDescription=text; this.setState({favoriteList:opt})      }}   />}




                          <View style={{flexDirection:"row", alignItems:"center", justifyContent:"center", marginTop:15}}>
                              {this.state.favoriteList[rowData].index!=undefined && <MavMiniButton color={"orange"}  maximize={true} icon={(style.mode=="dark")?require('../assets/back_black.png'):require('../assets/back_white.png')} text={strings.cancel} onlyButton={true}  onPress={()=>{ this['viewFavorite_' + i].close(); var opt=JSON.parse(JSON.stringify(this.state.favoriteList)); opt[rowData]=JSON.parse(JSON.stringify(this.state.favoriteListSave[rowData])); this.setState({favoriteList:opt})     }} />}
                              <MavMiniButton style={{marginLeft:(this.state.favoriteList[rowData].index!=undefined)?12:undefined, marginRight:12}} color={style.colorValidate} maximize={true} icon={(style.mode=="dark")?require('../assets/checkBasic_black.png'):require('../assets/checkBasic_white.png')} text={strings.validate} onlyButton={true}  onPress={()=>{ this.updateFavorite(rowData,i);    }} />
                              <MavMiniButton color={style.colorNotification} maximize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.remove} onlyButton={true}  onPress={()=>{ this.removeFavorite(rowData,i);  }} />

                          </View>
                    



                     
                    </TextPresentation>
                  ))}  



              </View>}



          {(this.state.viewMode=="favoriteAdmin" || this.state.viewMode=="favoriteUser") && <View style={{alignItems:"center",justifyContent:"center", marginTop:30,marginBottom:30}}> 
             <MavButton text={strings.add} onlyButton={true} onPress={()=>{ var opt=JSON.parse(JSON.stringify(this.state.favoriteList)); opt[generateUUID()]={name:"" }; this.setState({addFavoriteSelected:true, favoriteList:opt,},() =>{this['viewFavorite_' + (Object.keys(opt).length-1)].open(); })  }}/>

        </View>}
          
          </View>

      </ScrollView>}

      


      <MavAlert ref={alert => {this.alert = alert;}}/>

  </View>
  }</StyleContext.Consumer>
    );
  }
}




export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}
